import Contact from "@/components/contact/Contact";
import { config } from "@/config/config";
import Image from "next/image";
import Link from "next/link";

type Props = {};

export default function ContatoHome({}: Props) {
  return (
    <div className="rbt-become-area bg-color-white rbt-section-gap">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <span className="subtitle bg-primary">Contato</span>
              <h2 className="title">Ficou com dúvida?</h2>
              <p className="description has-medium-font-size mt--20 mb--40">Fale com o Téo ou mande uma mensagem</p>
            </div>
          </div>
        </div>
        <div className="row pt--60 g-5">
          <div className="col-lg-4">
            <div className="thumbnail">
              <Image
                src="/novos/img/teo-do-aule-grande.png"
                width="0"
                height="0"
                sizes="100vw"
                className="w-100 h-100 radius-10"
                alt="Aulé - O reforço que seu filho precisa para aprender"
                loading="eager"
              />
            </div>
            <div className="d-grid gap-5 mt-5">
              {config.contactInfo.map((data, index) => (
                <div key={index}>
                  <div className="icon icon-big color-secondary">
                    <i className={data.icon}></i>
                  </div>
                  <div className="row mt-4">
                    <span className="fs-2 fw-bold">{data.title}</span>
                    <span>{data.link ? <Link href={data.link}>{data.contact}</Link> : data.contact}</span>
                  </div>
                </div>
              ))}
              <div>
                <div className="icon icon-big color-secondary">
                  <i className="feather-help-circle"></i>
                </div>
                <div className="row mt-4">
                  <span className="fs-2 fw-bold">Dúvidas frequentes</span>
                  <span>
                    <Link href="/central-de-ajuda">Central de ajuda</Link>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <Contact />
          </div>
        </div>
      </div>
    </div>
  );
}

